import {getPreviousSibling} from "dauphine-js/src/utils";

const settings = {
    passwordContainer: '[js-show-password]',
    input: 'input',
    hideIcon: 'icon-eye-blind',
    showIcon: 'icon-eye'
}

const passwordContainers = document.querySelectorAll(settings.passwordContainer);

const togglePassword = element => {
    const input = getPreviousSibling(element, settings.input);

    if (input.type === 'text') {
        element.classList.remove(settings.hideIcon);
        element.classList.add(settings.showIcon);
        input.type = 'password';
    } else if (input.type === 'password') {
        element.classList.remove(settings.showIcon);
        element.classList.add(settings.hideIcon);
        input.type = 'text';
    }
}

if (passwordContainers) {
    Array.from(passwordContainers).map(containers => {
        containers.addEventListener('click', ({target}) => togglePassword(target));
    })
}
